module.exports = __webpack_public_path__ + "img/copyright.01268b15.png";